var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDudeSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 87,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0503C",
    d: "M89 87L66.75 64.952 44.5 87 22.25 64.952 0 87V0h89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F161A",
    d: "M61 11H39v22h22zM38.528 65.276L56.743 47.06l-6.123-6.123-12.03 12.029-5.953-5.953-6.186 6.186 12.077 12.077zM31 11H9v22h22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39 19v15h15zM8 19v15h15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDudeSuccess);
export default __webpack_public_path__ + "static/media/dude-success.984420a8.svg";
export { ForwardRef as ReactComponent };